/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { humanize, toTitleCase } from "uno-js";
import { GET_APPLICATION_DETAIL_FOR_CRO } from "../pages/CroApplicationDetails/graphql/getApplicationDetail.query";
import { GET_APPLICATION_DETAIL_FOR_OC } from "../pages/OcApplicationDetails/graphql/getApplicationDetail.query";
import { toast } from "react-hot-toast";
import { GET_REPORT_ADMIN } from "../pages/ReportDetails/graphql/report-details.query";
import { GET_APPLICATION_DETAIL_DOFT } from "../pages/DoftApplicationDetails/graphql/report-details.query";
import { REJECT_APPLICATION } from "../pages/DoftApplicationDetails/graphql/cancelApplication.mutation";
import SweetAlert from "sweetalert2";
import moment from "moment";

const MODULE_NAME = "GetApplicationDetail";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class GetApplicationDetailService {
    private static instance: GetApplicationDetailService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL;
    }
    public static getInstance(props: any = {}): GetApplicationDetailService {
        if (!GetApplicationDetailService.instance) {
            GetApplicationDetailService.instance =
                new GetApplicationDetailService(props);
        }
        return GetApplicationDetailService.instance;
    }

    getPersonalInfo(data: any) {
        let _output: any = [];
        if (data) {
            for (const [key, value] of Object.entries(data)) {
                if (
                    key === "employmentStatus" ||
                    key === "island" ||
                    key === "maritalStatus" ||
                    key === "nationality" ||
                    key === "placeOfBirth" ||
                    key === "applicationCurrentStatus" ||
                    key === "telephone" ||
                    key === "applicationId"
                    // key ==="passport"||
                    // key ==="address"
                ) {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? humanize(value) : "-",
                    });
                } else if (
                    key === "familyName" ||
                    key === "givenName" ||
                    key === "fatherName" ||
                    key === "motherName" ||
                    key === "province"
                ) {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? toTitleCase(value) : "-",
                    });
                } else if (key === "address") {
                    _output.push({
                        key: humanize(key.toString()),
                        value:
                            `${toTitleCase(value?.addressLine1)},` +
                            " " +
                            `${humanize(value?.addressLine2)},` +
                            " " +
                            `${humanize(value?.city)},` +
                            " " +
                            `${humanize(value?.state)},` +
                            " " +
                            `${humanize(value?.country)}`,
                    });
                } else if (key === "passport") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value?.passportCopyURL
                            ? value?.passportCopyURL
                            : "-",
                        type: "link",
                    });
                } else if (key === "uploadedReceiptURL") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                        type: "link",
                    });
                } else if (key === "birthCertificateCopyURL") {
                    _output.push({
                        key: "Birth Certificate",
                        value: value ? value : "-",
                        type: "link",
                    });
                } else if (key === "dateOfBirth") {
                    _output.push({
                        key: "Date of Birth",
                        value: moment(value).format("DD-MM-YYYY"),
                    });
                } else if (key === "appliedOn") {
                    _output.push({
                        key: "Applied On",
                        value: moment(value).format("DD-MM-YYYY"),
                    });
                } else if (
                    data.applicationType.isCitizen !== "Citizen" &&
                    key === "nonCitizenPOD"
                ) {
                    _output.push({
                        key: "Work Certificate",
                        value: value.workPermitCopyURL
                            ? value.workPermitCopyURL
                            : "-",
                        type: "link",
                    });

                    _output.push({
                        key: "Confirmation Letter",
                        value: value.confirmationLetterURL
                            ? value.confirmationLetterURL
                            : "-",
                        type: "link",
                    });

                    _output.push({
                        key: "Residential Permission",
                        value: value.residentialPermitCopyURL
                            ? value.residentialPermitCopyURL
                            : "-",
                        type: "link",
                    });
                }
            }
            console.log("diffOp", _output);
            return _output;
        }
    }

    getDoftComments(data: any) {
        let _output: any = [];
        let _messageOp: any = [];
        if (data?.paymentReceipt) {
            for (const [key, value] of Object.entries(data?.paymentReceipt)) {
                console.log("getDoftComments", key, value);
                if (key === "receiptId" || key === "transactionAmount") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                    });
                } else if (key === "receiptCopyURL") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                        type: "link",
                    });
                } else if (key === "transactionDate") {
                    _output.push({
                        key: "Transaction Date",
                        value: moment(value).format("DD-MM-YYYY"),
                    });
                } else if (key === "officer") {
                    _output.push({
                        key: "Officer Name",
                        value: toTitleCase(value?.fullName),
                    });
                    _output.push({
                        key: "Force Number",
                        value: value?.forceNo,
                    });
                    _output.push({
                        key: "Email",
                        value: value?.email,
                    });
                }
            }
            return _output;
        } else if (data?.applicationStatus?.length === 2) {
            if (data?.applicationStatus[1]?.message) {
                _messageOp.push({
                    key: "Cancellation Reason",
                    value: humanize(data?.applicationStatus[1]?.message),
                });
            }
            if (data?.applicationStatus[1]?.officer) {
                _messageOp.push({
                    key: "Email",
                    value: data?.applicationStatus[1]?.officer?.email,
                });
                _messageOp.push({
                    key: "Family Name",
                    value: toTitleCase(
                        data?.applicationStatus[1]?.officer?.familyName
                    ),
                });
                _messageOp.push({
                    key: "Full Name",
                    value: toTitleCase(
                        data?.applicationStatus[1]?.officer?.fullName
                    ),
                });
                _messageOp.push({
                    key: "Given Name",
                    value: toTitleCase(
                        data?.applicationStatus[1]?.officer?.givenName
                    ),
                });
            }
            return _messageOp;
        }
    }

    getCroComments(data: any) {
        console.log(
            "cro comments data in service",
            data?.applicationStatus?.length
        );
        let _output: any = [];
        let _messageOp: any = [];

        if (data?.assessment) {
            for (const [key, value] of Object.entries(data?.assessment)) {
                console.log("getCroComments", key, value);
                if (key === "comments") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                    });
                } else if (key === "receiptCopyURL") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                        type: "link",
                    });
                } else if (key === "officer") {
                    _output.push({
                        key: "Officer Name",
                        value: toTitleCase(value?.fullName),
                    });
                    _output.push({
                        key: "Force Number",
                        value: value?.forceNo,
                    });
                    _output.push({
                        key: "Email",
                        value: value?.email,
                    });
                }
            }
            return _output;
        } else if (data?.applicationStatus?.length === 3) {
            if (data?.applicationStatus[2]?.message) {
                _messageOp.push({
                    key: "Cancellation Reason",
                    value: humanize(data?.applicationStatus[2]?.message),
                });
            }
            if (data?.applicationStatus[2]?.officer) {
                _messageOp.push({
                    key: "Email",
                    value: data?.applicationStatus[2]?.officer?.email,
                });
                _messageOp.push({
                    key: "Family Name",
                    value: toTitleCase(
                        data?.applicationStatus[2]?.officer?.familyName
                    ),
                });
                _messageOp.push({
                    key: "Full Name",
                    value: toTitleCase(
                        data?.applicationStatus[2]?.officer?.fullName
                    ),
                });
                _messageOp.push({
                    key: "Given Name",
                    value: toTitleCase(
                        data?.applicationStatus[2]?.officer?.givenName
                    ),
                });
            }
            return _messageOp;
        }
    }

    getOCComments(data: any) {
        let _output: any = [];
        let _messageOp: any = [];
        if (data?.certificate) {
            for (const [key, value] of Object.entries(data?.certificate)) {
                console.log("rerer2", value);
                if (key === "CommissionerOfPolice") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? toTitleCase(value) : "-",
                    });
                } else if (key === "certificateCopyURL") {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                        type: "link",
                    });
                }
            }
            return _output;
        } else if (data?.applicationStatus?.length === 4) {
            if (data?.applicationStatus[3]?.message) {
                _messageOp.push({
                    key: "Cancellation Reason",
                    value: humanize(data?.applicationStatus[3]?.message),
                });
            }
            if (data?.applicationStatus[3]?.officer) {
                _messageOp.push({
                    key: "Email",
                    value: data?.applicationStatus[3]?.officer?.email,
                });
                _messageOp.push({
                    key: "Family Name",
                    value: toTitleCase(
                        data?.applicationStatus[3]?.officer?.familyName
                    ),
                });
                _messageOp.push({
                    key: "Full Name",
                    value: toTitleCase(
                        data?.applicationStatus[3]?.officer?.fullName
                    ),
                });
                _messageOp.push({
                    key: "Given Name",
                    value: toTitleCase(
                        data?.applicationStatus[3]?.officer?.givenName
                    ),
                });
            }
            return _messageOp;
        }
    }

    async getApplicationDetailForDOFT(applicationId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");

        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_DETAIL_DOFT,
                    variables: {
                        applicationId: applicationId,
                    },

                    fetchPolicy: "network-only",
                });
                log.success(
                    MODULE_NAME,
                    "getApplication detail : DOFT",
                    res?.data?.getApplicationById
                );
                if (res) {
                    return {
                        personalInfo: this.getPersonalInfo(
                            res?.data?.getApplicationById
                        ),
                        doftComments: this.getDoftComments(
                            res?.data?.getApplicationById
                        ),
                    };
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async getApplicationDetailForCRO(applicationId: string) {
        console.log("cro app detail service", applicationId);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");

        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_DETAIL_DOFT,
                    variables: {
                        applicationId: applicationId,
                    },

                    fetchPolicy: "network-only",
                });
                log.success(
                    MODULE_NAME,
                    "getApplication detail : ",
                    res?.data?.getApplicationById
                );
                if (res) {
                    // return res?.data?.getApplicationById;
                    return {
                        personalInfo: this.getPersonalInfo(
                            res?.data?.getApplicationById
                        ),
                        doftComments: this.getDoftComments(
                            res?.data?.getApplicationById
                        ),
                        croComments: this.getCroComments(
                            res?.data?.getApplicationById
                        ),
                    };
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async getApplicationDetailForOC(applicationId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");

        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_DETAIL_DOFT,
                    variables: {
                        applicationId: applicationId,
                    },

                    fetchPolicy: "network-only",
                });
                log.success(
                    MODULE_NAME,
                    "getApplication detail : ",
                    res?.data?.getApplicationById
                );
                if (res) {
                    return {
                        personalInfo: this.getPersonalInfo(
                            res?.data?.getApplicationById
                        ),
                        doftComments: this.getDoftComments(
                            res?.data?.getApplicationById
                        ),
                        croComments: this.getCroComments(
                            res?.data?.getApplicationById
                        ),
                        OCDetials: this.getOCComments(
                            res?.data?.getApplicationById
                        ),
                        offenceDetails:
                            res?.data?.getApplicationById?.assessment,
                    };
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async getApplicationDetailForAdmin(applicationId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");

        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_DETAIL_DOFT,
                    variables: {
                        applicationId: applicationId,
                    },

                    fetchPolicy: "network-only",
                });
                log.success(
                    MODULE_NAME,
                    "getApplication detail : ",
                    res?.data?.getApplicationById
                );
                if (res) {
                    return {
                        personalInfo: this.getPersonalInfo(
                            res?.data?.getApplicationById
                        ),
                        doftComments: this.getDoftComments(
                            res?.data?.getApplicationById
                        ),
                        croComments: this.getCroComments(
                            res?.data?.getApplicationById
                        ),
                        offenceDetails:
                            res?.data?.getApplicationById?.assessment,
                        OCDetials: this.getOCComments(
                            res?.data?.getApplicationById
                        ),
                    };
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async rejectApplication(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `Reject Application  data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: REJECT_APPLICATION,
                    variables: data,
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "Application Rejected result : ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
            // SweetAlert.fire(`${err?.graphQLErrors[0]?.message}`,'','error');
        }
    }
}
